import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const PrintOrderForm = lazy(() => import("@/pages/MyOrders/PrintPages/OrderForm/PrintOrderForm"));
const PrintPageForAllSamples = lazy(() => import("@/pages/MyOrders/PrintPages/AllSamples/PrintPageForAllSamples"));
const PrintPageForSingleSample = lazy(() => import("@/pages/MyOrders/PrintPages/SingleSample/PrintPageForSingleSample"));

const urlsConfig = new UrlsConfig();

export function printOrderRoutes() {
    return (
      <>
          <Route path={`${urlsConfig.printOrderForm.to}/:orderNum`} element={<PrintOrderForm/>}/>
          <Route path={`${urlsConfig.printAllSamplesPage.to}/:orderNum`} element={<PrintPageForAllSamples/>}/>
          <Route path={urlsConfig.printSingleSample({orderId: ":orderId", participantId: ":participantId"}).to}
                 element={<PrintPageForSingleSample/>}/>
      </>
    );
}
